import { useServerNotifications } from 'modules/Notifications/components/ServerNotificationsProvider';

export const useUserNotifications = () => {
  return useServerNotifications();
};
